import { readApiErrorMessage } from '@/shared/request-feedback';

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** O back só aceita o UUID inteiro (`@IsUUID`): busca exata, sem parcial. */
export function isUuid(value: string): boolean {
  return UUID_RE.test(value.trim());
}

/** O `code` da `DomainException`, que o filtro do monolith devolve em `error`. */
export function readApiErrorCode(err: unknown): string | null {
  const code = (err as { response?: { data?: { error?: unknown } } } | null)
    ?.response?.data?.error;
  return typeof code === 'string' ? code : null;
}

export type OfferRegisterField = 'account' | 'offer' | 'form';

/**
 * Onde e como cada erro do cadastro de oferta aparece. A tela distingue pelo
 * `code`, não pelo status: 404 é tanto conta inexistente quanto oferta que o
 * Guru não conhece, e 502 nunca mostra a mensagem crua da API.
 */
export function describeOfferRegisterError(err: unknown): {
  field: OfferRegisterField;
  message: string;
} {
  switch (readApiErrorCode(err)) {
    case 'GATEWAY_OFFER_NOT_FOUND':
      return {
        field: 'offer',
        message: 'O Guru não encontrou esta oferta neste produto.',
      };
    case 'INVALID_OFFER_PROVIDER':
      return {
        field: 'account',
        message: 'Só contas do Guru permitem conferir a oferta no provedor.',
      };
    case 'GATEWAY_RATE_LIMITED':
      return {
        field: 'form',
        message:
          'O provedor está limitando consultas agora, tente em um minuto.',
      };
    case 'GATEWAY_API_ERROR':
      return {
        field: 'form',
        message: 'Não foi possível consultar o provedor, tente de novo.',
      };
  }
  const status = (err as { response?: { status?: unknown } } | null)?.response
    ?.status;
  if (typeof status !== 'number' || status >= 500) {
    return {
      field: 'form',
      message: 'Não foi possível consultar o provedor, tente de novo.',
    };
  }
  return {
    field: 'form',
    message: readApiErrorMessage(err, 'Não foi possível cadastrar a oferta.'),
  };
}
